$(document).ready(function() {
    const $slideshow = $('.section-three-images-wrapper');

    const imagesSlider = function($slider) {
        $slider.slick({
            dots: true,
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 600,
            autoplay: true,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 770,
                    settings: 'unslick'
                }
            ]
        });
    }

    if ($slideshow.length) {

        $slideshow.each(function () {
            imagesSlider($(this));
        })

        $(window).resize(function () {
            $slideshow.each(function () {
                if ($(this).hasClass('slick-initialized')) {
                    $(this).slick('resize');
                } else {
                    imagesSlider($(this));
                }

            })
        });

    }
});

